import { render, staticRenderFns } from "./transformador.vue?vue&type=template&id=04246584"
import script from "./transformador.vue?vue&type=script&lang=js"
export * from "./transformador.vue?vue&type=script&lang=js"
import style0 from "./transformador.vue?vue&type=style&index=0&id=04246584&prod&rel=stylesheet%2Fscss&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports